import {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Sidebar } from "flowbite-react";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../../../auth/authContext/AuthContext";
import Permission from "../../../auth/Permission";
import "./SideMenu.scss";
import "../../../../../pages/MainLayout.scss";
import {
  FaUserFriends,
  FaPeopleArrows,
  FaBox,
  FaBoxes,
  FaMotorcycle,
  FaTools,
  FaTrailer,
  FaMoneyCheckAlt,
  FaFireExtinguisher,
  FaBuilding,
  FaFileInvoice,
  FaSearch,
  FaTrash,
  FaCarCrash,
} from "react-icons/fa";
import { RxDashboard } from "react-icons/rx";
import {
  GiFullMotorcycleHelmet,
  GiTeacher,
  GiReturnArrow,
} from "react-icons/gi";
import {
  BsClipboardData,
  BsClipboardCheck,
  BsSignStopLightsFill,
  BsCollectionPlayFill,
  BsPersonFillExclamation,
  BsWrenchAdjustableCircle,
} from "react-icons/bs";
import { BiSolidUserX } from "react-icons/bi";
import {
  MdCampaign,
  MdEngineering,
  MdOutlineAttachMoney,
  MdOutlineCreditScore,
  MdOutlineDragIndicator,
  MdOutlinePeople,
  MdOutlineSpaceDashboard,
  MdOutlineSupportAgent,
  MdWork,
} from "react-icons/md";
import { GrHostMaintenance, GrServices } from "react-icons/gr";
import { FaChevronDown, FaRegUser } from "react-icons/fa";
import { PiMotorcycleFill, PiUserSwitchDuotone, PiFiles } from "react-icons/pi";
import { SiCashapp, SiGoogleadsense } from "react-icons/si";
import {
  FaArrowRightArrowLeft,
  FaHandHoldingDollar,
  FaSackDollar,
  FaElementor,
  FaMeta,
  FaMessage,
} from "react-icons/fa6";

import { TbLockDollar, TbUserDollar, TbReportSearch } from "react-icons/tb";
import { RiNewspaperLine } from "react-icons/ri";
import {
  MdMonitorHeart,
  MdHomeRepairService,
  MdQuestionMark,
} from "react-icons/md";
import { CiStickyNote } from "react-icons/ci";
import { FaClipboardList } from "react-icons/fa6";
import { LuShoppingCart } from "react-icons/lu";
import { FiGitPullRequest } from "react-icons/fi";
import { IoSettingsOutline } from "react-icons/io5";

const MONITORING_PANEL_ALLOWED_EMAILS = [
  "wandson.helber@gmail.com",
  "rrochaalcantara@gmail.com",
  "giovanna.locavibe@gmail.com",
];

type MenuGroup = {
  label: string;
  icon: unknown;
  items: { permission: string; path: string; label: string; icon: unknown }[];
  path?: string;
  allowedEmails?: string[];
  badge?: boolean;
};

const menuStructure: { section: string; groups: MenuGroup[] }[] = [
  {
    section: "Principal",
    groups: [
      {
        label: "Dashboards",
        icon: RxDashboard,
        items: [
          {
            permission: "view:vehicles",
            path: "/dashboard/frota",
            label: "Frota",
            icon: PiMotorcycleFill,
          },
          {
            permission: "view:leads",
            path: "/dashboard/leads",
            label: "Comercial",
            icon: SiGoogleadsense,
          },
          {
            permission: "view:leads",
            path: "/dashboard/atendimento",
            label: "Atendimento",
            icon: MdOutlineSupportAgent,
          },
          {
            permission: "view:dashboard-maintenance",
            path: "/dashboard/manutencao",
            label: "Manutenção",
            icon: GrHostMaintenance,
          },
        ],
      },
    ],
  },
  {
    section: "Operações",
    groups: [
      {
        label: "Cadastros",
        icon: FaUserFriends,
        items: [
          {
            permission: "view:renters",
            path: "/clientes",
            label: "Ativos",
            icon: GiFullMotorcycleHelmet,
          },
          {
            permission: "view:delinquency",
            label: "Recolhimento/Aguardando",
            path: "/aguardandoRecisao",
            icon: BsPersonFillExclamation,
          },
          {
            permission: "view:delinquency",
            label: "Finalizado/Rescisão",
            path: "/finalizados",
            icon: BiSolidUserX,
          },
          {
            permission: "view:leads",
            label: "Leads",
            path: "/leads",
            icon: () => (
              <img src="/lead-icon.svg" className="h-5 w-5" alt="Leads" />
            ),
          },
          {
            permission: "view:indicators",
            label: "Embaixadores",
            path: "/indicadores",
            icon: FaPeopleArrows,
          },
          {
            permission: "view:partners",
            label: "Parceiros",
            path: "/parceiros",
            icon: () => (
              <img
                src="/partnes-icon.svg"
                className="h-5 w-5"
                alt="Parceiros"
              />
            ),
          },
          {
            permission: "view:suppliers",
            label: "Fornecedores",
            path: "/fornecedores",
            icon: FaBuilding,
          },
          {
            permission: "view:companies",
            path: "/company-management",
            label: "Empresas",
            icon: MdWork,
          },
          {
            permission: "view:companies",
            path: "/locacoesB2B",
            label: "Locações B2B",
            icon: MdWork,
          },
        ],
      },
      {
        label: "Frota",
        icon: MdEngineering,
        items: [
          {
            permission: "view:vehicles",
            label: "Gestão Operacional",
            path: "/operational-management",
            icon: MdOutlineSpaceDashboard,
          },
          {
            permission: "view:vehicles",
            label: "Manutenções",
            path: "/maintenances",
            icon: GrHostMaintenance,
          },
          {
            permission: "view:vehicles",
            label: "Veículos",
            path: "/veiculos",
            icon: FaMotorcycle,
          },
          {
            permission: "view:inventories",
            label: "Inventário",
            path: "/inventario",
            icon: FaBoxes,
          },
          {
            permission: "view:maintenance-schedule",
            label: "Agend. Manutenções",
            path: "/maintenance-schedules",
            icon: BsWrenchAdjustableCircle,
          },
          {
            permission: "view:maintenance",
            label: "Manutenção",
            path: "/manutencao",
            icon: FaTools,
          },
          {
            permission: "menu:repossession",
            label: "Recolhimento",
            path: "/recolhimento",
            icon: FaTrailer,
          },
          {
            permission: "menu:collision",
            label: "Colisão",
            path: "/dashboard/collision",
            icon: FaCarCrash,
          },
          {
            permission: "menu:events",
            label: "Eventos",
            path: "/event-claim",
            icon: FaFireExtinguisher,
          },
          {
            permission: "view:vehicles",
            label: "Transferências de Veículos",
            path: "/vehicle-transfer",
            icon: FaArrowRightArrowLeft,
          },
          {
            permission: "view:vehicles",
            label: "Auditorias",
            path: "/audits",
            icon: FaSearch,
          },
        ],
      },
    ],
  },
  {
    section: "Financeiro & Estoque",
    groups: [
      {
        label: "Financeiro",
        icon: FaMoneyCheckAlt,
        items: [
          {
            permission: "view:finance",
            label: "Gestão de Cobranças",
            path: "/financeiro/gestao-cobranca",
            icon: MdOutlineCreditScore,
          },
          {
            permission: "view:finance",
            label: "Cobranças Parceiros",
            path: "/financeiro/cobrancas-parceiros",
            icon: FaBuilding,
          },
          {
            permission: "view:finance",
            label: "Gestão de Faturas",
            path: "/financeiro/gestao-fatura",
            icon: FaHandHoldingDollar,
          },
          {
            permission: "view:finance",
            label: "Cobranças Negativadas",
            path: "/financeiro/negativados",
            icon: TbLockDollar,
          },
          {
            permission: "view:invoice-operation",
            label: "Gestão de Notas Fiscais",
            path: "/financeiro/gestao-fiscal",
            icon: FaFileInvoice,
          },
          {
            permission: "view:finance",
            label: "Boletos de Infrações",
            path: "/financeiro/infractionTickets",
            icon: RiNewspaperLine,
          },
          {
            permission: "view:finance",
            label: "Emprestimo",
            path: "/financeiro/emprestimo",
            icon: FaSackDollar,
          },
          {
            permission: "view:finance",
            label: "Devoluções de cauções",
            path: "/financeiro/caucao",
            icon: TbUserDollar,
          },
          {
            permission: "view:finance",
            label: "Renovações automaticas",
            path: "/financeiro/automaticRenewals",
            icon: PiUserSwitchDuotone,
          },
          {
            permission: "view:finance",
            label: "Histórico de exclusões",
            path: "/financeiro/historico-exclusoes",
            icon: FaTrash,
          },
        ],
      },
      {
        label: "Compras",
        icon: LuShoppingCart,
        items: [
          {
            permission: "view:inventory-workorder",
            label: "Requisições de Compras",
            path: "/compras/requestordem",
            icon: FiGitPullRequest,
          },
          {
            permission: "view:inventory-suppliers",
            label: "Ordem de Compras",
            path: "/compras/ordem",
            icon: LuShoppingCart,
          },
          {
            permission: "view:inventory-workorder",
            label: "Serviços Externos",
            path: "/compras/servicosExternos",
            icon: GrServices,
          },
          {
            permission: "view:inventory-workorder",
            label: "Notas Fiscais de Entrada",
            path: "/compras/NFSEntry",
            icon: FaFileInvoice,
          },
          {
            permission: "view:inventory-workorder",
            label: "Devoluções de Compra",
            path: "/compras/devolucao",
            icon: GiReturnArrow,
          },
        ],
      },
      {
        label: "Estoque",
        icon: FaBox,
        items: [
          {
            permission: "view:products",
            label: "Produtos",
            path: "/produtos",
            icon: FaClipboardList,
          },
          {
            permission: "view:works",
            label: "Serviços",
            path: "/servicos",
            icon: MdHomeRepairService,
          },
          {
            permission: "view:stocks",
            label: "Estoque",
            path: "/nfs",
            icon: FaBox,
          },
          {
            permission: "view:stocks",
            label: "Retirada de Estoque",
            path: "/retiradaDeEstoque",
            icon: CiStickyNote,
          },
          {
            permission: "view:stocks",
            label: "Ativo Imobilizado",
            path: "/controle-equipamentos",
            icon: TbReportSearch,
          },
          {
            permission: "view:stocks",
            label: "Inventário de Estoque",
            path: "/stock-inventario",
            icon: BsClipboardCheck,
          },
        ],
      },
    ],
  },
  {
    section: "Análises",
    groups: [
      {
        label: "Relatórios",
        icon: BsClipboardData,
        items: [
          {
            permission: "view:reports-maintenance",
            label: "Relatório de Manutenção",
            path: "/relatorios/manutencao",
            icon: GrHostMaintenance,
          },
          {
            permission: "view:reports-preparations",
            label: "Relatório de Preparações",
            path: "/relatorios/preparacoes",
            icon: FaMotorcycle,
          },
          {
            permission: "view:reports-trafficfines",
            label: "Relatório de Multas",
            path: "/relatorios/multas",
            icon: BsSignStopLightsFill,
          },
          {
            permission: "view:reports-repossession",
            label: "Relatório de Recolhimento",
            path: "/relatorios/recolhimento",
            icon: FaTrailer,
          },
          {
            permission: "view:reports-commissions",
            label: "Relatório de Bonificações",
            path: "/relatorios/comissoes",
            icon: SiCashapp,
          },
          {
            permission: "view:reports-commissions",
            label: "Relatório de Indicações",
            path: "/relatorios/RelatorioIndicacoes",
            icon: MdOutlineDragIndicator,
          },
          {
            permission: "view:reports-contests",
            label: "Contestações",
            path: "/relatorios/contestacoes",
            icon: FaElementor,
          },
          {
            permission: "view:inventory-workorder",
            label: "Sugestão de Compra",
            path: "/compras/sugestaoDeCompra",
            icon: MdQuestionMark,
          },
        ],
      },
    ],
  },
  {
    section: "Gestão",
    groups: [
      {
        label: "Recursos Humanos",
        icon: MdOutlinePeople,
        items: [
          {
            permission: "view:employee",
            label: "Colaboradores",
            path: "/colaboradores",
            icon: FaPeopleArrows,
          },
        ],
      },
      {
        label: "Marketing",
        icon: MdCampaign,
        items: [
          {
            permission: "view:marketing",
            label: "Template de Mensagens",
            path: "/marketing/messages-template",
            icon: FaMeta,
          },
          {
            permission: "view:marketing",
            label: "Campanhas",
            path: "/marketing/campaigns",
            icon: FaMessage,
          },
        ],
      },
    ],
  },
  {
    section: "Suporte & Monitoramento",
    groups: [
      {
        label: "Suporte",
        icon: BsCollectionPlayFill,
        badge: true,
        items: [
          {
            permission: "view:tutorial",
            label: "Tutorial",
            path: "/tutoriais",
            icon: GiTeacher,
          },
        ],
      },
      {
        label: "Painel Monitoramento",
        icon: MdMonitorHeart,
        allowedEmails: MONITORING_PANEL_ALLOWED_EMAILS,
        path: "/painel-monitoramento",
        items: [],
      },
    ],
  },
  {
    section: "Configurações",
    groups: [
      {
        label: "Configurações",
        icon: IoSettingsOutline,
        items: [
          {
            permission: "view:inventory-workorder",
            label: "Centro de Custos",
            path: "/compras/centroDeCustos",
            icon: MdOutlineAttachMoney,
          },
          {
            permission: "view:inventory-categories",
            label: "Categorias de Compras",
            path: "/compras/categorias",
            icon: PiFiles,
          },
          {
            permission: "view:categories",
            label: "Categoria de Produtos",
            path: "/categorias",
            icon: FaMotorcycle,
          },
          {
            permission: "view:inventory-workorder",
            label: "Solicitantes de Compras",
            path: "/compras/solicitante",
            icon: FaRegUser,
          },
        ],
      },
    ],
  },
];

/* ── Animated collapse wrapper ──────────────────────── */
function AnimatedCollapse({
  isOpen,
  children,
}: {
  isOpen: boolean;
  children: React.ReactNode;
}) {
  const contentRef = useRef<HTMLDivElement>(null);
  const [maxHeight, setMaxHeight] = useState(0);

  useEffect(() => {
    if (contentRef.current) {
      setMaxHeight(contentRef.current.scrollHeight);
    }
  }, [isOpen, children]);

  return (
    <div
      className={`sidebar-subitems-container ${isOpen ? "sidebar-subitems-open" : ""}`}
      style={{ maxHeight: isOpen ? maxHeight : 0 }}
    >
      <div ref={contentRef}>{children}</div>
    </div>
  );
}

export default function DefaultSidebar() {
  const { auth } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  /* ---------- regra de embaixador ---------- */
  const isAmbassador = useMemo(() => {
    const roles = auth?.user?.roles ?? [];
    return roles.length === 1 && roles.includes("ambassador");
  }, [auth]);

  const userEmail = auth?.user?.email ?? "";

  /* Flatten sections into groups for ambassador filtering */
  const allGroups = useMemo(() => {
    return menuStructure.flatMap((s) => s.groups);
  }, []);

  const structureToRender = useMemo(() => {
    if (isAmbassador) {
      const cadastros = allGroups.find((g) => g.label === "Cadastros");
      return cadastros ? [{ section: "Principal", groups: [cadastros] }] : [];
    }
    return menuStructure
      .map((section) => ({
        ...section,
        groups: section.groups.filter(
          (g) => !g.allowedEmails || g.allowedEmails.includes(userEmail),
        ),
      }))
      .filter((s) => s.groups.length > 0);
  }, [isAmbassador, userEmail, allGroups]);

  /* ---------- render state ---------- */
  const [isSideMenuNames, setIsSideMenuNames] = useState(false);
  const [openGroups, setOpenGroups] = useState<Record<string, boolean>>({});

  useEffect(() => {
    const stored = localStorage.getItem("openGroups");
    if (stored && !isAmbassador) setOpenGroups(JSON.parse(stored));
    const sidebar = document.querySelector(".side-bar");
    let t: ReturnType<typeof setTimeout>;
    const enter = () => (t = setTimeout(() => setIsSideMenuNames(true), 1000));
    const leave = () => {
      clearTimeout(t);
      setIsSideMenuNames(false);
    };
    sidebar?.addEventListener("mouseenter", enter);
    sidebar?.addEventListener("mouseleave", leave);
    return () => {
      sidebar?.removeEventListener("mouseenter", enter);
      sidebar?.removeEventListener("mouseleave", leave);
      clearTimeout(t);
    };
  }, [isAmbassador]);

  const isActive = useCallback(
    (path: string) => location.pathname.startsWith(path),
    [location.pathname],
  );

  const toggleGroup = (label: string) => {
    setOpenGroups((prev) => {
      const updatedState: Record<string, boolean> = {};
      Object.keys(prev).forEach((key) => {
        updatedState[key] = false;
      });
      updatedState[label] = !prev[label];
      localStorage.setItem("openGroups", JSON.stringify(updatedState));
      return updatedState;
    });
  };

  if (isAmbassador) {
    const ambassadorGroups = structureToRender[0]?.groups ?? [];
    return (
      <div className="side-menu">
        <Sidebar className="side-bar">
          <Sidebar.Items>
            <Sidebar.ItemGroup className="sidebar-items-reports">
              {ambassadorGroups[0]?.items.map((subItem) => (
                <Permission key={subItem.path} permission={subItem.permission}>
                  <Sidebar.Item
                    className={`sidebar-item ${
                      isActive(subItem.path) ? "sidebar-item-active" : ""
                    }`}
                    onClick={() => navigate(subItem.path)}
                    icon={subItem.icon}
                  >
                    {subItem.label}
                  </Sidebar.Item>
                </Permission>
              ))}
            </Sidebar.ItemGroup>
          </Sidebar.Items>
        </Sidebar>
      </div>
    );
  }

  return (
    <div className="side-menu">
      <Sidebar className="side-bar">
        <Sidebar.Items>
          <Sidebar.ItemGroup>
            <div
              id="sideBarNames"
              className={`side-menu_entities ${isSideMenuNames ? "show" : ""}`}
            >
              {structureToRender.map((section) => (
                <div key={section.section}>
                  {section.groups.map((group) => {
                    // Item direto (sem submenu)
                    if (group.path) {
                      return (
                        <div key={group.label}>
                          <Sidebar.Item
                            className={`sidebar-item ${isActive(group.path) ? "sidebar-item-active" : ""} sidebar-group`}
                            icon={group.icon}
                            onClick={() => navigate(group.path!)}
                          >
                            <span>{group.label}</span>
                            <div className="sidebar-active-indicator" />
                          </Sidebar.Item>
                        </div>
                      );
                    }

                    const groupItems = group.items.filter((item) => {
                      if (item.permission === "__email_restricted__")
                        return true;
                      return auth?.user?.permissions?.includes(item.permission);
                    });

                    if (groupItems.length === 0) return null;

                    const isGroupActive = groupItems.some((item) =>
                      isActive(item.path),
                    );
                    const isOpen = openGroups[group.label];

                    return (
                      <div key={group.label}>
                        <Sidebar.Item
                          className={`sidebar-item ${
                            isGroupActive ? "sidebar-item-active" : ""
                          } sidebar-group ${isOpen ? "sidebar-group-open" : ""}`}
                          icon={group.icon}
                          onClick={() => toggleGroup(group.label)}
                        >
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              width: "100%",
                            }}
                          >
                            <span>{group.label}</span>
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              {group.badge && (
                                <span className="sidebar-badge">!</span>
                              )}
                              <FaChevronDown className="sidebar-chevron" />
                            </span>
                          </span>
                          <div className="sidebar-active-indicator" />
                        </Sidebar.Item>
                        <AnimatedCollapse isOpen={!!isOpen}>
                          <Sidebar.Items className="sidebar-items-reports">
                            {groupItems.map((item) => {
                              const sidebarItem = (
                                <Sidebar.Item
                                  key={item.path}
                                  className={`sidebar-item sidebar-subitem ${isActive(item.path) ? "sidebar-item-active" : ""}`}
                                  icon={item.icon}
                                  onClick={() => navigate(item.path)}
                                >
                                  {item.label}
                                  <div className="sidebar-active-indicator" />
                                </Sidebar.Item>
                              );
                              if (item.permission === "__email_restricted__") {
                                return sidebarItem;
                              }
                              return (
                                <Permission
                                  key={item.path}
                                  permission={item.permission}
                                >
                                  {sidebarItem}
                                </Permission>
                              );
                            })}
                          </Sidebar.Items>
                        </AnimatedCollapse>
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
          </Sidebar.ItemGroup>
        </Sidebar.Items>
      </Sidebar>
    </div>
  );
}
